<template>
  <a-modal
    :title="isEdit ? $t('edit') : $t('create')"
    :visible="visible"
    @ok="() => save()"
    @cancel="() => cancel()"
  >
    <a-form :form="form" :label-col="{ span: 7 }" :wrapper-col="{ span: 14 }">
      <a-form-item :label="$t('page_organization_superior_department')">
        <a-tree-select
          v-decorator="[
            'parentId',
            {
              initialValue: (isEdit && editItem.pId) || undefined,
              rules: [{ required: true, message: $t('page_organization_select_superior_department') }]
            }
          ]"
          :placeholder="$t('page_organization_select_superior_department')"
          tree-data-simple-mode
          style="width: 100%"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="treeData"
        />
      </a-form-item>
      <a-form-item :label="$t('page_work_order_execution_depart_name')">
        <a-input
          v-decorator="[
            'name',
            {
              initialValue: (isEdit && editItem.title) || '',
              rules: [{ required: true, message: $t('page_organization_enter_depart_name') }]
            }
          ]"
          :placeholder="$t('page_organization_enter_depart_name')"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { OrganizationServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'

const osp = new OrganizationServiceProxy()
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Array,
      default: () => []
    },
    editItem: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: this.$form.createForm(this)
    }
  },
  methods: {
    cancel() {
      this.form.resetFields()
      this.$emit('cancel')
    },
    save() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.isEdit && this.editItem && this.editItem.key) {
            values.id = this.editItem.key
          }
          osp.submit(values).then(() => {
            this.$message.success(this.isEdit ? this.$t('page_ops_customer_edit_succee') : this.$t('page_ops_customer_new_success'))
            this.$emit('save')
            this.form.resetFields()
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
